import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "DataShare"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3.75 18.75V11.871L1.0605 14.5605L0 13.5L4.5 9L9 13.5L7.9395 14.5605L5.25 11.871V18.75H14.25V20.25H5.25C4.42192 20.2492 3.75083 19.5781 3.75 18.75ZM18 16.5H21C21.8281 16.5008 22.4992 17.1719 22.5 18V21C22.4992 21.8281 21.8281 22.4992 21 22.5H18C17.1719 22.4992 16.5008 21.8281 16.5 21V18C16.5008 17.1719 17.1719 16.5008 18 16.5ZM21 21V18H17.9985L18 21H21ZM20.25 4.5V11.379L22.9395 8.6895L24 9.75L19.5 14.25L15 9.75L16.0605 8.6895L18.75 11.379V4.5H9.75V3H18.75C19.5781 3.00083 20.2492 3.67192 20.25 4.5ZM1.5 4.5H6V6H1.5V4.5ZM1.5 1.5H7.5V3H1.5V1.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/DataShare.vue"]]);
